var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0417 5.95833H16.0508M6.41666 1.83333H15.5833C18.1146 1.83333 20.1667 3.88536 20.1667 6.41666V15.5833C20.1667 18.1146 18.1146 20.1667 15.5833 20.1667H6.41666C3.88536 20.1667 1.83333 18.1146 1.83333 15.5833V6.41666C1.83333 3.88536 3.88536 1.83333 6.41666 1.83333ZM14.6667 10.4225C14.7798 11.1854 14.6495 11.9645 14.2943 12.6491C13.9391 13.3337 13.377 13.8888 12.6882 14.2355C11.9993 14.5823 11.2186 14.703 10.4571 14.5804C9.69569 14.4579 8.99228 14.0984 8.44693 13.5531C7.90159 13.0077 7.54208 12.3043 7.41956 11.5429C7.29703 10.7814 7.41772 10.0007 7.76446 9.31184C8.1112 8.62294 8.66633 8.06092 9.3509 7.70572C10.0355 7.35051 10.8146 7.2202 11.5775 7.33333C12.3557 7.44872 13.0761 7.81134 13.6324 8.36761C14.1887 8.92388 14.5513 9.64432 14.6667 10.4225Z",
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.fea3c312162e52f924fab6fa2ea0e788.svg";
export { ForwardRef as ReactComponent };